<template>
  <div class="page-view">
    <div class="side-menu">
      <ul class="menu-list">
        <!-- allworks -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works`"
          active-class="active"
          exact
        >
          <a href="javascript:;">{{ t.allWorks.menu }}</a>
        </router-link>
        <!-- Discography -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/discography`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.discography }}</a>
        </router-link>
        <!--  Biography -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/biography`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.biography }}</a>
        </router-link>
        <!-- Albums -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/albums`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.albums }}</a>
        </router-link>
        <!-- Compilations -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/compilations`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.compilations }}</a>
        </router-link>
        <!-- Collaborations -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/collaborations`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.collaborations }}</a>
        </router-link>
        <!-- Singles -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/singles`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.singles }}</a>
        </router-link>
        <!--  Single 45rpms -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/singles_45rpms`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.singles_45rpms }}</a>
        </router-link>
        <!--  Soundtrack -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/albums_list/soundtrack`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.albums.soundtrack }}</a>
        </router-link>
        <!-- All Works (search song page) -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/works`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.allSongs.name }}</a>
        </router-link>
        <!-- Books -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/books`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.publication }}</a>
        </router-link>
        <!-- DVD -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/dvd`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.dvd }}</a>
        </router-link>
        <!-- Products -->
        <router-link
          class="menu-btn"
          tag="li"
          :to="`/${lng}/all_works/products`"
          active-class="active"
        >
          <a href="javascript:;">{{ t.allWorks.products }}</a>
        </router-link>
      </ul>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["t", "lng"]),
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/colors";
.page-view {
  background: #e7e7e7;
  display: flex;
  flex-wrap: wrap;
  @media screen and (max-width: 760px) {
    flex-direction: column;
  }
  /* side menu */
  .side-menu {
    width: 260px;
    padding: 30px 5px 10px;
    @media screen and (max-width: 760px) {
      width: 100%;
    }
    ul.menu-list {
      // mobile menu
      @media screen and (max-width: 760px) {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
      }
      li.menu-btn {
        margin: 5px;
        @media screen and (max-width: 760px) {
          margin: 2px;
        }
        a {
          background: #87888a;
          color: #fff;
          padding: 7px 7px 7px 17px;
          font-size: 14px;
          display: block;
          @media screen and (max-width: 760px) {
            padding: 7px 17px;
          }
        }
        &.active {
          a {
            background: $main;
          }
        }
      }
    }
  }
  /*  CONTENT */
  .content {
    flex: 1;
    position: relative;
    padding: 10px 20px;
    width: 100%;
    @media screen and (max-width: 760px) {
      flex: 1 auto;
    }
  }
}
</style>
